//@flow
import { view } from "ramda";

import { type State } from "../../state";
import { carregandoFuncaoQtlinkLens, funcaoQtlinkLens } from "../lenses";

export const getFuncaoQtLink: (state: State) => string = view(funcaoQtlinkLens);

export const carregandoFuncaoQtLink: (state: State) => boolean = view(
  carregandoFuncaoQtlinkLens
);
